export function getPositionFromTime(
    time: number,
    duration: number,
    containerWidth: number,
): number {
    if (duration === 0 || containerWidth === 0) return 0;
    return (time / duration) * containerWidth;
}

export function getTimeFromPosition(
    position: number,
    duration: number,
    containerWidth: number,
): number {
    if (containerWidth === 0) return 0;
    return (position / containerWidth) * duration;
}

export function processDisplayThumbnails(
    thumbnails: string[],
    displayCount: number,
): string[] {
    if (thumbnails.length === 0) return [];

    const validThumbnails = thumbnails.filter(Boolean);
    if (validThumbnails.length === 0) return [];

    const result: string[] = [];
    const repeatFactor = Math.ceil(displayCount / validThumbnails.length);

    for (let i = 0; i < displayCount; i++) {
        const sourceIndex =
            Math.floor(i / repeatFactor) % validThumbnails.length;
        result.push(validThumbnails[sourceIndex]);
    }

    return result;
}
